import axios from 'axios';
const protocol = process.env.REACT_APP_DAILYPROFIT_BACKEND_PROTOCOL;
const url = process.env.REACT_APP_DAILYPROFIT_BACKEND_HOST;
const port = process.env.REACT_APP_DAILYPROFIT_BACKEND_PORT;
const crmBaseUrl = `${protocol}${url}${port}`;

const getCrmCreationAccess = async (lang = 'en') => {
    try {
        return await axios.get(`${crmBaseUrl}/boards/getCrmCreationAccess`, { params: { lang } });
    } catch (error) {
        return error?.response || false;
    }
};

const createBoard = async (name, lang) => {
    try {
        return await axios.post(`${crmBaseUrl}/boards/createBoard`, { name, ...(lang ? { lang } : {}) });
    } catch (error) {
        return error?.response || false;
    }
};

const getStandaloneBoards = async () => {
    try {
        return await axios.get(`${crmBaseUrl}/boards/getStandaloneBoards`);
    } catch {
        return false;
    }
};

const withShareToken = (params = {}, shareToken = "") => {
    if (!shareToken) return params;
    return { ...params, shareToken };
}

const saveBoard = (questId, columns, shareToken = "") => {

    return new Promise((resolve, reject) => {

        axios.post(`${crmBaseUrl}/boards/saveBoard`, {questId, columns, shareToken })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('SAVE BOARD')
            resolve(false);
        })
    })
}

const getBoard = (questId, startDate, endDate, shareToken = "" ) => {

    return new Promise((resolve, reject) => {
        const params = withShareToken({ questId }, shareToken);
        if (startDate) params.startDate = startDate;
        if (endDate) params.endDate = endDate;

        axios.get(`${crmBaseUrl}/boards/getBoard`, { params })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('GET BOARD')
            resolve(false);
        })
    })
}

const renameWebsiteBoard = async (boardId, name) => {
    try {
        return await axios.patch(`${crmBaseUrl}/integrations/wordpress/boards/${boardId}`, { name });
    } catch (error) {
        return error?.response || false;
    }
}


const getUserBoards = (startDate, endDate ) => {

    return new Promise((resolve, reject) => {
        const params = {  };
        if (startDate) params.startDate = startDate;
        if (endDate) params.endDate = endDate;

        axios.get(`${crmBaseUrl}/boards/getUserBoards`, { params })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('GET BOARD')
            resolve(false);
        })
    })
}



const searchLeads = (questId , q, shareToken = "") => {

    return new Promise((resolve, reject) => {
        const params = withShareToken({ questId, q }, shareToken);
     

        axios.get(`${crmBaseUrl}/boards/searchLeads`, { params })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('GET BOARD')
            resolve(false);
        })
    })
}

const searchUserLeads = (q) => {
    return new Promise((resolve) => {
        axios.get(`${crmBaseUrl}/boards/searchUserLeads`, {
            params: { q }
        })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('SEARCH USER LEADS')
            resolve(false);
        })
    })
}

const getUserCalls = ({ timing = "all", assignee = "all", page = 0, limit = 30 } = {}) => {
    return new Promise((resolve) => {
        axios.get(`${crmBaseUrl}/boards/getUserCalls`, {
            params: {
                timing,
                assignee,
                page,
                limit,
                timezoneOffset: new Date().getTimezoneOffset(),
            }
        })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('GET USER CALLS')
            resolve(false);
        })
    })
}

const serializeCallFilter = (value) => Array.isArray(value) ? value.join(",") : value || "all";

const getBoardSharing = (questId, shareToken = "") => {
    return new Promise((resolve) => {
        axios.get(`${crmBaseUrl}/boards/getBoardSharing`, {
            params: withShareToken({ questId }, shareToken)
        })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('GET BOARD SHARING')
            resolve(false);
        })
    })
}

const updateBoardLinkSharing = (questId, enabled) => {
    return new Promise((resolve) => {
        axios.post(`${crmBaseUrl}/boards/updateBoardLinkSharing`, {
            questId,
            enabled
        })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('UPDATE BOARD LINK SHARING')
            resolve(false);
        })
    })
}

const shareBoard = (questId, email) => {
    return new Promise((resolve) => {
        axios.post(`${crmBaseUrl}/boards/shareBoard`, {
            questId,
            email
        }, {
            validateStatus: () => true
        })
        .then(res => {
            if (res?.status && res.status >= 400) {
                resolve({
                    ...res,
                    data: res?.data || {},
                    error: res?.data?.error || res?.data?.msg || null,
                });
                return;
            }
            resolve(res);
        })
        .catch((err) => {
            console.error('SHARE BOARD')
            if (err?.response) {
                resolve({
                    ...err.response,
                    data: err.response?.data || {},
                    error: err.response?.data?.error || err.response?.data?.msg || err.message || null,
                });
                return;
            }
            resolve(false);
        })
    })
}

const unshareBoard = (questId, email, userId) => {
    return new Promise((resolve) => {
        axios.post(`${crmBaseUrl}/boards/unshareBoard`, {
            questId,
            email,
            userId
        })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('UNSHARE BOARD')
            resolve(false);
        })
    })
}

const getColumnLeads = (questId, columnId, skip, limit = 30, search = '', startDate, endDate, shareToken = "", callFilters = {}, source = 'all') => {
     return new Promise((resolve, reject) => {
        const params = withShareToken({
            questId,
            columnId,
            skip,
            limit,
            search,
            startDate,
            endDate,
            source,
            callTiming: serializeCallFilter(callFilters?.timing),
            callAssignee: serializeCallFilter(callFilters?.assignee),
            callOutcome: serializeCallFilter(callFilters?.outcome),
            timezoneOffset: new Date().getTimezoneOffset(),
        }, shareToken)
     

        axios.get(`${crmBaseUrl}/boards/getColumnLeads`, { params })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('GET BOARD')
            resolve(false);
        })
    })
//   return axios.get(`${crmBaseUrl}/boards/getColumnLeads`, {
//     params: { questId, columnId, skip, limit, search, startDate, endDate }
//   });
};

const moveLeadToQuest = (payload) => {
    console.log('payload', payload);
    
    return new Promise((resolve, reject) => {

        axios.post(`${crmBaseUrl}/boards/moveLeadToQuest`, {payload })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('SAVE BOARD')
            resolve(false);
        })
    })
}

const moveLead = (payload) => {
    console.log('payload', payload);
    
    return new Promise((resolve, reject) => {

        axios.post(`${crmBaseUrl}/boards/moveLead`, {payload })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('SAVE BOARD')
            resolve(false);
        })
    })
}

const reorderLead = (payload) => {

    return new Promise((resolve, reject) => {

        axios.post(`${crmBaseUrl}/boards/reorderLead`, {payload })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('SAVE BOARD')
            resolve(false);
        })
    })
}


const updateColumn = (payload) => {

    return new Promise((resolve, reject) => {

        axios.post(`${crmBaseUrl}/boards/updateColumn`, {payload })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('SAVE BOARD')
            resolve(false);
        })
    })
}


const getLeadColumns = (questId, leadIds, shareToken = "" ) => {

    return new Promise((resolve, reject) => {
     
        axios.post(`${crmBaseUrl}/boards/getLeadColumns`,  {
            questId,
            leadIds,
            shareToken
        })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('GET BOARD')
            resolve(false);
        })
    })
}

const createColumn = (questId, columnId, title, color, shareToken = "" ) => {

    return new Promise((resolve, reject) => {
     
        axios.post(`${crmBaseUrl}/boards/createColumn`,  { questId, columnId, title, color, shareToken })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('create column')
            resolve(false);
        })
    })
}


const deleteColumn = (questId, columnId, shareToken = "" ) => {

    return new Promise((resolve, reject) => {
     
        axios.post(`${crmBaseUrl}/boards/deleteColumn`,  { questId, columnId, shareToken })
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('Delete column')
            resolve(false);
        })
    })
}

const exportLeads = (payload) => {

    return new Promise((resolve) => {

        axios.post(`${crmBaseUrl}/boards/exportLeads`, payload)
        .then(res => {
            resolve(res);
        })
        .catch(() => {
            console.error('EXPORT LEADS')
            resolve(false);
        })
    })
}


//  moveLead: (payload) => axios.post(`${base}/boards/moveLead`, payload),
//   reorderLead: (payload) => axios.post(`${base}/boards/reorderLead`, payload),
//   updateColumn: (payload) => axios.patch(`${base}/boards/updateColumn`, payload),

const boardEndpoints = {
    createBoard,
    getCrmCreationAccess,
    getStandaloneBoards,
    saveBoard,
    getBoard,
    renameWebsiteBoard,
    getUserBoards,  
    searchLeads,
    searchUserLeads,
    getUserCalls,
    getBoardSharing,
    updateBoardLinkSharing,
    shareBoard,
    unshareBoard,
    getColumnLeads,
    moveLeadToQuest,
    moveLead,
    reorderLead,
    updateColumn,
    getLeadColumns,
    createColumn, 
    deleteColumn,
    exportLeads
}

export default boardEndpoints;
